import { render } from "./FindId.vue?vue&type=template&id=053974b8&scoped=true"
import script from "./FindId.vue?vue&type=script&lang=js"
export * from "./FindId.vue?vue&type=script&lang=js"

import "./FindId.vue?vue&type=style&index=0&id=053974b8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-053974b8"]])

export default __exports__